export default function termsSummaryPlugin(md) {
	md.block.ruler.before('fence', 'header', function (state, startLine, endLine, silent) {
		let pos = state.bMarks[startLine] + state.tShift[startLine]
		let max = state.eMarks[startLine]
		let line = state.src.slice(pos, max)

		if (!line.startsWith(':::')) return false

		line = line.slice(3)
		let title = ''
		let content = ''

		if (line.startsWith('header[')) {
			const titleStart = line.indexOf('[') + 1
			const titleEnd = line.indexOf(']')
			if (titleEnd !== -1) {
				title = line.slice(titleStart, titleEnd)
				line = line.slice(titleEnd + 1)
			}
		}

		if (silent) return true

		const token = state.push('header_open', 'div', 1)
		token.attrSet('class', 'flex items-center gap-3')

		const titleToken = state.push('header_title', 'div', 1)
		titleToken.attrSet('class', 'whitespace-nowrap text-xs font-medium uppercase text-white')
		titleToken.content = title || 'Terms Summary'

		const lineToken = state.push('header_line', 'div', 1)
		lineToken.attrSet('class', 'h-[1px] w-full bg-white')

		state.push('header_close', 'div', -1)

		state.line = startLine + 1
		return true
	})

	md.renderer.rules.header_open = function () {
		return '<div class="flex items-center gap-3 mb-5 mt-10">'
	}

	md.renderer.rules.header_title = function (tokens, idx) {
		return `<div class="whitespace-nowrap text-xs font-bold uppercase text-white">${tokens[idx].content}</div>`
	}

	md.renderer.rules.header_line = function () {
		return '<div class="h-[1px] w-full bg-white"></div>'
	}

	md.renderer.rules.header_close = function () {
		return '</div>'
	}
}
